import React, { useState, useEffect } from 'react';

function DynamicIcon({ iconName, alt, className, ...props }) {
  const [iconSrc, setIconSrc] = useState(null);
  useEffect(() => {
    let isMounted = true;

    import(`../../../assets/icons/${iconName}`)
      .then((module) => {
        if (isMounted) {
          setIconSrc(module.default);
        }
      })
      .catch((error) => {
        console.error(`Error loading icon ${iconName}:`, error);
        // Optionally, set a default icon or handle the error
        if (isMounted) {
          setIconSrc(null); // Or set to a fallback icon
        }
      });

    return () => {
      isMounted = false;
    };
  }, [iconName]);

  if (!iconSrc) {
    return <div>Loading...</div>; // Or any other fallback UI
  }

  return <img className={className} src={iconSrc} alt={alt} {...props} />;
}

export default DynamicIcon;
